import { userApi } from '@/features/user/userApi';
import { clientsApi } from '@/features/clients/clientsApi';
import { dealsApi } from '@/features/deals/dealsApi';
import { contactsApi } from '@/features/contacts/contactsApi';
import { pipelineApi } from '@/features/pipelines/pipelineApi';
import { engagementsApi } from '@/features/engagements/engagementsApi';
import { announcementsApi } from '@/features/announcements/announcementsApi';
import { factFindApi } from '@/features/factFind/factFindApi';
import { ticketsApi } from '@/features/claims/ticketsApi';
import { propertiesApi } from '@/features/properties/propertiesApi';
import { formsApi } from '@/features/forms/formsApi';
import { filesApi } from '@/features/files/filesApi';
import { msGraphApi } from '@/features/msGraph/msGraphApi';
import { templatesApi } from '@/features/templates/templatesApi';
import { configApi } from '@/features/config/configApi';
import { policiesApi } from '@/features/policies/policiesApi';
import { classesOfRiskApi } from '@/features/classesOfRisk/classesOfRiskApi';
import { aiWorkflowApi } from '@/features/aiWorkflow/aiWorkflowApi';
import { unlayerEmailTemplatesApi } from '@/features/unlayerEmailTemplates/unlayerEmailTemplatesApi';
import { unlayerDocumentTemplatesApi } from '@/features/unlayerDocumentTemplates/unlayerDocumentTemplatesApi';
import { unlayerUserSignaturesApi } from '@/features/unlayerUserSignatures/unlayerUserSignaturesApi';
import { notificationsApi } from '@/features/notifications/notificationsApi';
import { authorisationApi } from '@/features/authorisation/authorisation';
import { workspacesApi } from '@/features/workspaces/workspacesApi';
import { complianceStepsApi } from '../../features/complianceSteps/complianceStepsApi';
import { askAiApi } from '@/features/askAi/askAiApi.js';
import { supportApi } from '@/features/support/supportApi';
import { tenantConsentApi } from '@/features/tenantConsent/tenantConsentApi';
import { unlayerAiEmailTemplatesApi } from '@/features/unlayerAiEmailTemplates/unlayerAiEmailTemplates';
import { insightFieldsApi } from '@/features/insightFields';
import { automationsApi } from '@/features/automations/automationsApi';
import { additionalFoldersApi } from '@/features/additionalFolders/additionalFoldersApi';
import { auditApi } from '@/features/audit/auditApi';
import { relationshipContactsApi } from '@/features/relationshipContacts/relationshipContactsApi';
import { relationshipCompaniesApi } from '@/features/relationshipCompanies/relationshipCompaniesApi';
import { adminApi } from '@/admin/api/adminApi';

// Add additional apis here for Redux Store
const apis = [
	userApi,
	clientsApi,
	contactsApi,
	relationshipContactsApi,
	relationshipCompaniesApi,
	dealsApi,
	ticketsApi,
	pipelineApi,
	engagementsApi,
	factFindApi,
	propertiesApi,
	announcementsApi,
	supportApi,
	msGraphApi,
	formsApi,
	filesApi,
	classesOfRiskApi,
	templatesApi,
	configApi,
	aiWorkflowApi,
	policiesApi,
	unlayerEmailTemplatesApi,
	unlayerDocumentTemplatesApi,
	unlayerUserSignaturesApi,
	notificationsApi,
	workspacesApi,
	authorisationApi,
	complianceStepsApi,
	askAiApi,
	tenantConsentApi,
	unlayerAiEmailTemplatesApi,
	insightFieldsApi,
	automationsApi,
	additionalFoldersApi,
	auditApi,
	adminApi,
];
export default apis;
